import useAxios from './useAxios'
import { useUser } from './useUser'

import { ERecipientPhoneRule, IMerchant } from '../types/merchant'
import { setMerchantCache } from '../utils/cache'
import { normalizeRecipientPhoneRule } from '../utils/recipient-phone-rule.util'

// the cached merchant lives 12h, so a rule changed on another browser would not apply until then
export const useRecipientPhoneRule = (): ERecipientPhoneRule => {
  const { merchant } = useUser()
  const { data: freshMerchant } = useAxios<Partial<IMerchant>>(
    { url: '/merchant/me' },
    { onSuccess: (response) => setMerchantCache(response.data) },
  )

  const config = freshMerchant ? freshMerchant.config : merchant.config
  return normalizeRecipientPhoneRule(config?.recipientPhoneRule)
}
